import script from "./RadiogroupElement_tabs.vue?vue&type=script&lang=js"
export * from "./RadiogroupElement_tabs.vue?vue&type=script&lang=js"

import "./RadiogroupElement_tabs.vue?vue&type=style&index=0&id=46b5e49c&lang=scss"

const __exports__ = script;

export default __exports__